import { GraphQLNonNull, GraphQLID } from 'graphql'
import { ServerFilterArgType, ServerFilterArg } from './server-filter-arg'

export interface ServerAggregationArgs {
  readonly organizationID: string
  readonly filters?: ServerFilterArg
}

export const serverAggregationArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  filters: {
    description: 'Options for filtering servers',
    type: ServerFilterArgType
  }
}
